@if (!loadingCapture) {
  <div class="capture-detail">
    <div class="capture-fixed mb-1"><app-capture-header [capture]="capture" /></div>
    @if (!loadingHistoryItems) {
      <div class="capture-history">
        <table class="table table-striped mt-3">
          <tbody>
            @for (captureHistoryItem of captureHistoryItems; track captureHistoryItem) {
              <tr>
                <td class="datetime">
                  <div>{{ captureHistoryItem.createdAt | date: 'MM/dd/yyyy' }}</div>
                  <div>{{ captureHistoryItem.createdAt | date: 'hh:mm a' }}</div>
                </td>
                <td>
                  <div>
                    @switch (captureHistoryItem.action) {
                      @case (captureHistoryItemActions.created) {
                        <app-capture-history-item-type-created
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.updated) {
                        <app-capture-history-item-type-updated
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.transitioned) {
                        <app-capture-history-item-type-transitioned
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.reprocessingStarted) {
                        <app-capture-history-item-type-reprocessing-started
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.unreversed) {
                        <app-capture-history-item-type-unreversed
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.snapshotCreated) {
                        <app-capture-history-item-type-snapshot-created
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.verifyingPatientAttachmentAssociated) {
                        <app-capture-history-item-type-verifying-patient-attachment-associated
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.consultNoteSubmitted) {
                        <app-capture-history-item-type-consult-note-submitted
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.referralMatchVerificationSubmitted) {
                        <app-capture-history-item-type-referral-match-verification-submitted
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @default {
                        <app-capture-history-item-type-base
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.locationAdded) {
                        <app-capture-history-item-type-location-added
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.developerChoreUpdated) {
                        <app-capture-history-item-type-developer-chore-updated
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.clientChoreStarted) {
                        <app-capture-history-item-type-client-chore-started
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.clientChoreUpdated) {
                        <app-capture-history-item-type-client-chore-updated
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.claimStatusUpdated) {
                        <app-capture-history-item-type-claim-status-updated
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.clientNoteAdded) {
                        <app-capture-history-item-type-client-note-added
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.clientNoteRemoved) {
                        <app-capture-history-item-type-client-note-removed
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.nuvemArpClaimImported) {
                        <app-capture-history-item-type-nuvem-arp-claim-imported
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                      @case (captureHistoryItemActions.estimatedValueUpdated) {
                        <app-capture-history-item-type-estimated-value-updated
                          [captureHistoryItem]="captureHistoryItem" />
                      }
                    }
                  </div>
                </td>
                <td class="user-details">
                  <div class="user">
                    {{ captureHistoryItem.user.fullName }}
                  </div>
                  @if (captureHistoryItem.initiatingUser) {
                    <div class="small">
                      Initiated by {{ captureHistoryItem.initiatingUser.fullName }}
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <mat-spinner />
    }
  </div>
} @else {
  <mat-spinner />
}
